export default class BrowserPushNotifications {

  constructor (panel, querySelector, applicationServerKey, subscriptionUrl) {
    this.isPushEnabled = false;
    this.browserSupportsPushNotifications = true;
    this.pushPermissionDeniedByUser = false;
    this.panel = panel;
    this.pushButton = document.querySelector(querySelector);
    this.applicationServerKey = applicationServerKey;
    this.subscriptionUrl = subscriptionUrl;
    this.isAlreadySubscribed = false;

    this.checkIfPushEnabled();

    const self = this;

    if (this.browserSupportsPushNotifications && !this.userDeniedPushNotifications()) {
      console.log('Taurai:HELLO');
      navigator.serviceWorker.register('/ServiceWorker.js').then(
        () => {
          console.log('[SW] Service worker has been registered');
          self.updatePushSubscription();
        },
        e => {
          console.error('[SW] Service worker registration failed', e);
          self.changePushButtonState('incompatible');
        }
      );

      if (this.pushButton) {
        this.pushButton.addEventListener('click', () => {
          if (self.isPushEnabled) {
            self.pushUnsubscribe();
          } else {
            self.pushSubscribe();
          }
        });
      }
    }
  }


  supportsPushNotifications() {
    return this.browserSupportsPushNotifications;
  }

  userDeniedPushNotifications() {
    return this.pushPermissionDeniedByUser;
  }

  checkIfPushEnabled() {
    if (!('serviceWorker' in navigator)) {
      console.warn('Service workers are not supported by this browser');
      this.changePushButtonState('incompatible');
      return;
    }

    if (!('PushManager' in window)) {
      console.warn('Push notifications are not supported by this browser');
      this.changePushButtonState('incompatible');
      return;
    }

    if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
      console.warn('Notifications are not supported by this browser');
      this.changePushButtonState('incompatible');
      return;
    }

    // Check the current Notification permission.
    // If its denied, the button should appears as such, until the user changes the permission manually
    if (Notification.permission === 'denied') {
      this.pushPermissionDeniedByUser = true;
      console.warn('Notifications are denied by the user');
      this.changePushButtonState('incompatible');
    }
  }

  changePushButtonState(state) {
    switch (state) {
      case 'enabled':
        this.updatePushButtonState(false, 'Disable Push notifications');
        this.isPushEnabled = true;
        break;
      case 'disabled':
        this.updatePushButtonState(false, 'Enable Push notifications');
        this.isPushEnabled = false;
        break;
      case 'computing':
        this.updatePushButtonState(true, 'Loading...');
        break;
      case 'incompatible':
        this.updatePushButtonState(true, 'Push notifications are not compatible with this browser');
        this.browserSupportsPushNotifications = false;
        break;
      default:
        console.error('Unhandled push button state', state);
        break;
    }
  }

  updatePushButtonState(state, text) {
    console.log('Taurai:updatePushButtonState:', state, text);
    if (this.pushButton) {
      this.pushButton.disabled = state;
      this.pushButton.textContent = text;
    }
  }


  pushSubscribe() {

    console.log('Taurai: pushSubscribe');
    this.changePushButtonState('computing');
    const self = this;
    console.log('Taurai: Button is ' + this.isPushEnabled);
    this.checkNotificationPermission()
      .then(() => navigator.serviceWorker.ready)
      .then(serviceWorkerRegistration =>
        serviceWorkerRegistration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: self.urlBase64ToUint8Array(self.applicationServerKey),
        })
      )
      .then(subscription => {
        // Subscription was successful
        // create subscription on your server
        return self.sendSubscriptionToServer(subscription, 'POST');
      })
      .then(subscription => subscription && self.changePushButtonState('enabled')) // update your UI
      .catch(e => {
        console.log('Taurai:pushSubscribe error', e);
        if (Notification.permission === 'denied') {
          // The user denied the notification permission which
          // means we failed to subscribe and the user will need
          // to manually change the notification permission to
          // subscribe to push messages
          console.warn('Notifications are denied by the user.');
          self.changePushButtonState('incompatible');
        } else {
          // A problem occurred with the subscription; common reasons
          // include network errors or the user skipped the permission
          console.error('Impossible to subscribe to push notifications', e);
          self.changePushButtonState('disabled');
        }
      });
  }

  pushUnsubscribe() {
    this.isAlreadySubscribed = false;
    this.changePushButtonState('computing');
    const self = this;
    // To unsubscribe from push messaging, you need to get the subscription object
    navigator.serviceWorker.ready
      .then(serviceWorkerRegistration => serviceWorkerRegistration.pushManager.getSubscription())
      .then(subscription => {
        // Check that we have a subscription to unsubscribe
        if (!subscription) {
          // No subscription object, so set the state
          // to allow the user to subscribe to push
          self.changePushButtonState('disabled');
          return;
        }

        // We have a subscription, unsubscribe
        // Remove push subscription from server
        return self.sendSubscriptionToServer(subscription, 'DELETE');
      })
      .then(subscription => subscription.unsubscribe())
      .then(() => self.changePushButtonState('disabled'))
      .catch(e => {
        // We failed to unsubscribe, this can lead to
        // an unusual state, so  it may be best to remove
        // the users data from your data store and
        // inform the user that you have done so
        console.error('Error when unsubscribing the user', e);
        self.changePushButtonState('disabled');
      });
  }

  checkNotificationPermission() {
    const self = this;
    return new Promise((resolve, reject) => {
      if (self.isAlreadySubscribed) {
        return;
      }

      console.log('Taurai:checkNotificationPermission', Notification.permission);
      if (Notification.permission === 'denied') {
        return reject(new Error('Push messages are blocked.'));
      }

      if (Notification.permission === 'granted') {
        return resolve();
      }

      if (Notification.permission === 'default') {
        if (self.checkNotificationPromise()) {
          console.log('Taurai:requestPermission:IF');
          return Notification.requestPermission().then( function (result) {
            console.log('Taurai:promise:'+result);
            if (result !== 'granted') {
              return reject(new Error('Bad permission result'));
            }

            return resolve();
          }, function (err) {
            console.log('Taurai:requestPermission:ERROR:', err);
          });
        } else {
          console.log('Taurai:requestPermission:ELSE');
          Notification.requestPermission(function (result) {
            if (result !== 'granted') {
              return reject(new Error('Bad permission result'));
            }

            return resolve();
          });
        }
      }
    });
  }

  checkNotificationPromise() {
    try {
      Notification.requestPermission().then();
    } catch(e) {
      return false;
    }

    return true;
  }

  urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  updatePushSubscription() {
    const self = this;
    navigator.serviceWorker.ready
      .then(serviceWorkerRegistration => serviceWorkerRegistration.pushManager.getSubscription())
      .then(subscription => {
        self.changePushButtonState('disabled');

        if (!subscription) {
          // We aren't subscribed to push, so set UI to allow the user to enable push
          return;
        }
        self.isAlreadySubscribed = true;
        // Keep your server in sync with the latest endpoint
        return self.sendSubscriptionToServer(subscription, 'PUT');
      })
      .then(subscription => subscription && self.changePushButtonState('enabled')) // Set your UI to show they have subscribed for push messages
      .catch(e => {
        console.error('Error when updating the subscription', e);
      });
  }

  sendSubscriptionToServer(subscription, method) {
    console.log('Taurai:sendSubscriptionToServer', subscription, method);
    const key = subscription.getKey('p256dh');
    const token = subscription.getKey('auth');
    const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0];

    this.panel.post(this.subscriptionUrl, {
      method: method,
      body: JSON.stringify({
        endpoint: subscription.endpoint,
        publicKey: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
        authToken: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
        contentEncoding,
      }),
    }, (response) => {
      console.log('Taurai: ', response);
    });
  }
}


// document.addEventListener('DOMContentLoaded', () => {
//   /**
//    * START send_push_notification
//    * this part handles the button that calls the endpoint that triggers a notification
//    * in the real world, you wouldn't need this, because notifications are typically sent from backend logic
//    */
//
//   const sendPushButton = document.querySelector('#send-push-button');
//   if (!sendPushButton) {
//     return;
//   }
//
//   sendPushButton.addEventListener('click', () =>
//     navigator.serviceWorker.ready
//       .then(serviceWorkerRegistration => serviceWorkerRegistration.pushManager.getSubscription())
//       .then(subscription => {
//         if (!subscription) {
//           alert('Please enable push notifications');
//           return;
//         }
//
//         const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0];
//         const jsonSubscription = subscription.toJSON();
//         fetch('send_push_notification.php', {
//           method: 'POST',
//           body: JSON.stringify(Object.assign(jsonSubscription, { contentEncoding })),
//         });
//       })
//   );
//   /**
//    * END send_push_notification
//    */
// });



// WEBPACK FOOTER //
// ./src/app/lib/BrowserPushNotifications.js